<template>
  <div>
    <loading
      :active="isLoading"
      loader="bars"
      color="#7367f0"
      :is-full-page="fullPage"
    />
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      finish-button-text="Submit"
      back-button-text="Previous"
      class="steps-transparent mb-3"
      @on-complete="formSubmitted"
    >
      <!-- Scheduling -->
      <tab-content
        title="Schedule"
        icon="feather icon-calendar"
        :before-change="validationFormSchedule"
      >
        <validation-observer
          ref="schedule"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Schedule
              </h5>
              <small class="text-muted">
                Enter the GMS church name, open date, close date and maximum approval date.
              </small>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                vid="openDate"
                name="Open Date"
                rules="required|open_date_validation:@closeDate,@maximumApprovalDate"
              >
                <b-form-group
                  label="Open date"
                  label-for="open_date"
                  :state="errors.length > 0 ? false:null"
                >
                  <b-form-datepicker
                    v-model="open_date"
                    class="mb-1"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                vid="closeDate"
                name="Close date"
                rules="required|close_date_validation:@openDate,@maximumApprovalDate"
              >
                <b-form-group
                  label="Close Date"
                  label-for="close_date"
                  :state="errors.length > 0 ? false:null"
                >
                  <b-form-datepicker
                    v-model="close_date"
                    class="mb-1"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="12">
              <validation-provider
                #default="{ errors }"
                vid="maximumApprovalDate"
                name="Maximum approval date"
                rules="required|approval_date_validation:@openDate,@closeDate"
              >
                <b-form-group
                  label="Maximum Approval Date"
                  label-for="maximum_approval_date"
                  :state="errors.length > 0 ? false:null"
                >
                  <b-form-datepicker
                    v-model="maximum_approval_date"
                    class="mb-1"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- Requirements -->
      <tab-content
        title="Requirements"
        icon="feather icon-shield"
        :before-change="validationFormRequirements"
      >
        <validation-observer
          ref="requirements"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Requirement Details
              </h5>
              <small class="text-muted">Customize your requirements.</small>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="NIJ Requirement"
                rules="required"
              >
                <b-form-group
                  label="NIJ Required ?"
                  label-for="nij_required"
                  :state="errors.length > 0 ? false:null"
                >
                  <div
                    class="demo-inline-spacing"
                    style="margin-top: -15px;"
                  >
                    <b-form-radio
                      v-model="nij_required"
                      value="yes"
                      class="custom-control-primary"
                    >
                      Yes
                    </b-form-radio>
                    <b-form-radio
                      v-model="nij_required"
                      value="no"
                      class="custom-control-secondary"
                    >
                      No
                    </b-form-radio>
                  </div>
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Baptism Requirement"
                rules="required"
              >
                <b-form-group
                  label="Baptism Required ?"
                  label-for="baptism_required"
                  :state="errors.length > 0 ? false:null"
                >
                  <div
                    class="demo-inline-spacing"
                    style="margin-top: -15px;"
                  >
                    <b-form-radio
                      v-model="baptism_required"
                      value="yes"
                      class="custom-control-primary"
                    >
                      Yes
                    </b-form-radio>
                    <b-form-radio
                      v-model="baptism_required"
                      value="no"
                      class="custom-control-secondary"
                    >
                      No
                    </b-form-radio>
                  </div>
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                #default="{ errors }"
                name="Assessment Broadcasted Requirement"
                rules="required"
              >
                <b-form-group
                  label="Is Assessment Broadcasted ?"
                  label-for="isAssessmentBroadcasted"
                  :state="errors.length > 0 ? false:null"
                >
                  <div
                    class="demo-inline-spacing"
                    style="margin-top: -15px;"
                  >
                    <b-form-radio
                      v-model="isAssessmentBroadcasted"
                      value="yes"
                      class="custom-control-primary"
                    >
                      Yes
                    </b-form-radio>
                    <b-form-radio
                      v-model="isAssessmentBroadcasted"
                      value="no"
                      class="custom-control-secondary"
                    >
                      No
                    </b-form-radio>
                  </div>
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="12">
              <validation-provider
                #default="{ errors }"
                name="MSJ Requirement"
                rules="required"
              >
                <b-form-group
                  label="MSJ Requirement"
                  :state="errors.length > 0 ? false:null"
                >
                  <v-select
                    v-model="msjSelected"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="msjOptions"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Terms & Conditions"
              >
                <quill-editor
                  v-model="termsConditions"
                  :options="snowOption"
                  @change="onEditorChange($event)"
                  @ready="onEditorReady($event)"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- Ministry Types -->
      <tab-content
        title="Ministry Types"
        icon="feather icon-type"
        :before-change="validationFormMinistryTypes"
      >
        <validation-observer
          ref="ministryTypes"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Ministry Type
              </h5>
              <small class="text-muted">Determine the ministry and division type.</small>
            </b-col>
          </b-row>
          <!-- <b-row v-if="moment(moment().format('YYYY-MM-DD')).isBefore(moment(moment(open_date).format('YYYY-MM-DD')))"> -->
          <b-row>
            <b-col
              v-if="moment(moment().format('YYYY-MM-DD')).isBefore(moment(moment(open_date).format('YYYY-MM-DD')))"
              cols="12"
              class="mb-2"
            >
              <validation-provider
                #default="{ errors }"
                name="Servolution Type"
                rules="required"
              >
                <b-form-group
                  label="Servolution Type"
                  :state="errors.length > 0 ? false:null"
                >
                  <v-select
                    v-model="servolutionType"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="servolutionTypeOptions"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col v-else>
              <b-form-group
                label="Servolution Type"
                label-for="servolutionType"
              >
                <b-form-input
                  id="servolutionType"
                  v-model="readOnlyServolutionType"
                  plaintext
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <!-- <b-row v-if="moment(moment().format('YYYY-MM-DD')).isBefore(moment(moment(open_date).format('YYYY-MM-DD'))) && servolutionType.id === 1"> -->
            <b-col
              v-if="moment(moment().format('YYYY-MM-DD')).isBefore(moment(moment(open_date).format('YYYY-MM-DD'))) && servolutionType.id === 1"
              cols="12"
              class="mb-2"
            >
              <validation-provider
                #default="{ errors }"
                name="Type of First and Second Option"
                rules="required"
              >
                <b-form-group
                  label="Choose the type of first and second option"
                  :state="errors.length > 0 ? false:null"
                >
                  <v-select
                    v-model="firstSecondMinistryType"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="firstSecondMinistryTypeOptions"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col v-else-if="servolutionType.id === 1">
              <b-form-group
                label="Type of First and Second Option"
                label-for="firstSecondOptionType"
              >
                <b-form-input
                  id="firstSecondOptionType"
                  v-model="readOnlyFirstSecondMinistryType"
                  plaintext
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <!-- <b-row v-if="moment(moment().format('YYYY-MM-DD')).isBefore(moment(moment(open_date).format('YYYY-MM-DD')))"> -->
            <!-- Audition Type -->
            <b-col md="6">
              <h6 class="text-primary font-weight-bold mb-2">
                Audition & Interview
              </h6>

              <!-- draggable -->
              <draggable
                :list="auditions"
                tag="ul"
                group="people"
                class="list-group list-group-flush cursor-move"
              >
                <b-list-group-item
                  v-for="(listItem, index) in auditions"
                  :key="index"
                  tag="li"
                >
                  <div class="d-flex">
                    <div class="ml-25">
                      <b-card-text class="mb-0 font-weight-bold">
                        {{ listItem.ministry }}
                      </b-card-text>
                      <small>{{ listItem.division }}</small>
                    </div>
                  </div>
                </b-list-group-item>
              </draggable>
            </b-col>

            <!-- Interview Type -->
            <b-col
              md="6"
              class="mt-sm-2 mt-md-0"
            >
              <h6 class="text-primary font-weight-bold mb-2">
                Interview Only
              </h6>

              <!-- draggable -->
              <draggable
                :list="interviews"
                tag="ul"
                group="people"
                class="list-group list-group-flush cursor-move"
              >
                <b-list-group-item
                  v-for="(listItem, index) in interviews"
                  :key="index"
                  tag="li"
                >
                  <div class="d-flex">
                    <div class="ml-25">
                      <b-card-text class="mb-0 font-weight-bold">
                        {{ listItem.ministry }}
                      </b-card-text>
                      <small>{{ listItem.division }}</small>
                    </div>
                  </div>
                </b-list-group-item>
              </draggable>
            </b-col>
          </b-row>
          <!-- <b-row v-if="(moment(moment().format('YYYY-MM-DD')).isSameOrAfter(moment(moment(open_date).format('YYYY-MM-DD'))) && moment(moment().format('YYYY-MM-DD')).isSameOrBefore(moment(moment(close_date).format('YYYY-MM-DD')))) || (moment(moment().format('YYYY-MM-DD')).isAfter(moment(moment(close_date).format('YYYY-MM-DD'))))">
            <b-col md="12">
              <b-alert
                variant="warning"
                show
              >
                <div class="alert-body">
                  <span>This section can't be accessed anymore. Please continue to click <strong>Next</strong> button.</span>
                </div>
              </b-alert>
            </b-col>
          </b-row> -->
        </validation-observer>
      </tab-content>

      <!-- Ministry Options -->
      <tab-content
        title="Ministry Options"
        icon="feather icon-check-circle"
        :before-change="validationFormMinistryOptions"
      >
        <validation-observer
          ref="ministryOptions"
          tag="form"
        >
          <b-row v-if="servolutionType">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Ministry Options
              </h5>
              <small class="text-muted">Set the ministry options that the users will choose.</small>
            </b-col>
            <b-col
              v-if="servolutionType.id === 1"
              md="12"
            >
              <!-- <b-col
                v-if="servolutionType.id === 1 && moment(moment().format('YYYY-MM-DD')).isBefore(moment(moment(open_date).format('YYYY-MM-DD')))"
                md="12"
              > -->
              <validation-provider
                #default="{ errors }"
                name="First Options"
                rules="required"
              >
                <b-form-group
                  label="First Options"
                  :state="errors.length > 0 ? false:null"
                >
                  <v-select
                    v-model="firstOptionLists"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    multiple
                    label="name"
                    :options="firstOptionListsOptions"
                    @option:selected="firstOptionSelected"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="servolutionType.id === 1"
              md="12"
            >
              <!-- <b-col
                v-if="servolutionType.id === 1 && moment(moment().format('YYYY-MM-DD')).isBefore(moment(moment(open_date).format('YYYY-MM-DD')))"
                md="12"
              > -->
              <validation-provider
                #default="{ errors }"
                name="Second Options"
                rules="required"
              >
                <b-form-group
                  label="Second Options"
                  :state="errors.length > 0 ? false:null"
                >
                  <v-select
                    v-model="secondOptionLists"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    multiple
                    label="name"
                    :options="secondOptionListsOptions"
                    @option:selected="secondOptionSelected"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="servolutionType.id === 2"
              md="12"
            >
              <!-- <b-col
                v-if="servolutionType.id === 2 && moment(moment().format('YYYY-MM-DD')).isBefore(moment(moment(open_date).format('YYYY-MM-DD')))"
                md="12"
              > -->
              <validation-provider
                #default="{ errors }"
                name="Options"
                rules="required"
              >
                <b-form-group
                  label="Options"
                  :state="errors.length > 0 ? false:null"
                >
                  <v-select
                    v-model="servolutionOptionLists"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    multiple
                    label="name"
                    :options="servolutionOptionListsOptions"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- <b-col
              v-if="(moment(moment().format('YYYY-MM-DD')).isSameOrAfter(moment(moment(open_date).format('YYYY-MM-DD'))) && moment(moment().format('YYYY-MM-DD')).isSameOrBefore(moment(moment(close_date).format('YYYY-MM-DD')))) || (moment(moment().format('YYYY-MM-DD')).isAfter(moment(moment(close_date).format('YYYY-MM-DD'))))"
              md="12"
            >
              <b-alert
                variant="warning"
                show
              >
                <div class="alert-body">
                  <span>This section can't be accessed anymore. Please continue to click <strong>Submit</strong> button.</span>
                </div>
              </b-alert>
            </b-col> -->
          </b-row>
        </validation-observer>
      </tab-content>
    </form-wizard>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import _ from 'lodash'
import vSelect from 'vue-select'
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Loading from 'vue-loading-overlay'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import 'vue-loading-overlay/dist/vue-loading.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormDatepicker,
  BFormRadio,
  BListGroupItem,
  BCardText,
  BFormInvalidFeedback,
  // BAlert,
} from 'bootstrap-vue'
import draggable from 'vuedraggable'
import Ripple from 'vue-ripple-directive'
// import Cookies from 'js-cookie'
import CryptoJS from 'crypto-js'
import * as moment from 'moment'
import { quillEditor } from 'vue-quill-editor'
import { required, email } from '@validations'
import { isUserLoggedIn } from '@/auth/utils'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    vSelect,
    Loading,
    BFormDatepicker,
    BFormRadio,
    draggable,
    BListGroupItem,
    BCardText,
    quillEditor,
    BFormInvalidFeedback,
    BFormInput,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    // BAlert,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      isLoading: true,
      fullPage: true,
      moment,
      servolutionEvents: {},
      churches: [],
      churchOptions: [],
      event: {},
      open_date: '',
      close_date: '',
      maximum_approval_date: '',
      nij_required: '',
      baptism_required: '',
      isAssessmentBroadcasted: '',
      msjSelected: { id: 2, name: 'MSJ 2' },
      msjOptions: [
        { id: 1, name: 'MSJ 1' },
        { id: 2, name: 'MSJ 2' },
      ],
      snowOption: {
        theme: 'snow',
      },
      termsConditions: '<h3><span style="font-weight: bolder;">Syarat</span></h3><ol style="font-size: 14px;"><li>Telah lulus MSJ (My Spiritual Journey) 2.</li><li>Sudah Baptis Selam.</li><li>Sudah menerima Baptisan Roh Kudus.</li><li>Aktif di dalam keanggotaan Connect Group (CG).</li><li>Rekomendasi pemimpin CG (untuk memastikan kesiapan member dalam melayani)<span class="Apple-converted-space" style="font-family: Calibri; font-size: 11.5px;"> </span>.</li></ol><h3><span style="font-weight: bolder;">Ketentuan</span></h3><ol style="font-size: 14px;"><li>Pendaftaran servolution dilakukan secara online melalui apps GMS Church lalu klik icon <span style="font-weight: bolder;"><span style="font-weight: bolder;">Servolution</span></span>.</li><li>Pendaftaran dibuka mulai <span style="font-weight: bolder;"><span style="font-weight: bolder;">{diisi}</span></span></li><li>Pastikan GMS tempat dimana anda beribadah sudah sesuai di bagian Edit Profile, GMS (city), yaitu <span style="font-weight: bolder;"><span style="font-weight: bolder;">{{diisi}}</span></span></li><li>Apabila Anda belum pernah melengkapi data baptisan, maka sebelum memilih pelayanan, Anda diwajibkan melengkapi data baptisan Anda terlebih dahulu.</li><li>Hanya diperbolehkan mengambil satu bidang pelayanan saja.</li><li>Peserta yang mendaftar pada departemen yang memerlukan audisi, wajib memilih opsi kedua pilihan departemen (sebagai bentuk antisipasi apabila tidak lolos pada audisi departemen opsi pertama).</li><li>Data Baptisan Anda akan diverifikasi terlebih dahulu sebelum lanjut ke proses persetujuan pemimpin (bagi Peserta yang belum pernah melengkapi data baptisan).<br></li><li>Jadwal serta ketentuan audisi dan interview akan diinformasikan melalui aplikasi GMS Church/Email atau melalui departemen yang bersangkutan.</li><li>Nomor Mobile Phone (HP) dan Email yang disertakan harus aktif. Jika ada informasi yang disampaikan lewat HP/Email dan Anda tidak menerimanya dikarenakan kesalahan penulisan atau nomor/email yang tidak aktif, maka segala resiko bukan tanggung jawab kami, contoh: tidak diterima di pelayanan.</li><li>Syarat kelengkapan (dilampirkan via online pada saat mendaftar) seperti <span style="font-weight: bolder;">Foto Diri.</span></li><li>Kelulusan akan diumumkan melalui Push Notification di Aplikasi GMS Church dan Email.</li></ol>',
      termsConditionsLength: 1,
      servolutionType: [],
      readOnlyServolutionType: '',
      servolutionTypeOptions: [],
      firstSecondMinistryType: [],
      readOnlyFirstSecondMinistryType: '',
      firstSecondMinistryTypeOptions: [
        { id: 0, name: 'Optional' },
        { id: 1, name: 'Mandatory' },
      ],
      required,
      email,
      auditions: [],
      interviews: [],
      columns: [
        {
          label: 'Ministry',
          field: 'ministry',
        },
        {
          label: 'Division',
          field: 'division',
        },
      ],
      rows: [],
      firstOptionLists: [],
      firstOptionListsOptions: [],
      secondOptionLists: [],
      secondOptionListsOptions: [],
      servolutionOptionLists: [],
      servolutionOptionListsOptions: [],
    }
  },
  created() {
    // Open date validation
    extend('open_date_validation', {
      params: ['close', 'approval'],
      validate(value, { close, approval }) {
        const openDate = moment(value).format('YYYY-MM-DD')
        const closeDate = moment(close).format('YYYY-MM-DD')
        const maximumApprovalDate = moment(approval).format('YYYY-MM-DD')

        return moment(openDate).isBefore(closeDate) && moment(openDate).isBefore(maximumApprovalDate)
      },
      message: 'The open date must be less than the close and maximum approval date',
    })

    // Close date validation
    extend('close_date_validation', {
      params: ['open', 'approval'],
      validate(value, { open, approval }) {
        const openDate = moment(open).format('YYYY-MM-DD')
        const closeDate = moment(value).format('YYYY-MM-DD')
        const maximumApprovalDate = moment(approval).format('YYYY-MM-DD')

        return moment(closeDate).isBetween(openDate, maximumApprovalDate)
      },
      message: 'The close date must be between open and maximum approval date',
    })

    // Maximum approval date validation
    extend('approval_date_validation', {
      params: ['open', 'close'],
      validate(value, { open, close }) {
        const openDate = moment(open).format('YYYY-MM-DD')
        const closeDate = moment(close).format('YYYY-MM-DD')
        const maximumApprovalDate = moment(value).format('YYYY-MM-DD')

        return moment(maximumApprovalDate).isAfter(openDate) && moment(maximumApprovalDate).isAfter(closeDate)
      },
      message: 'The maximum approval date must be greater than the open and close date',
    })
  },
  async mounted() {
    // Always set to empty array
    this.servolutionOptionListsOptions = []
    this.firstOptionListsOptions = []
    this.secondOptionListsOptions = []

    // Set data
    const userData = JSON.parse(CryptoJS.AES.decrypt(sessionStorage.getItem('userData'), process.env.VUE_APP_COOKIE_SECRET).toString(CryptoJS.enc.Utf8))
    const churchIds = userData[0].churches.map(elem => elem).join(',')

    // Church
    const churches = await this.$http.get(`${process.env.VUE_APP_API_BASE_URL}/api/churches/${churchIds}`)
    _.forEach(churches.data, church => {
      this.churchOptions.push({ id: church.couchdbId, name: church.name, status: church.status })
    })

    // Get event data
    const event = await this.$http.get(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/events/${this.$route.params.id}`)
    this.event = event.data
    const divisions = await this.$http.get(`${process.env.VUE_APP_API_BASE_URL}/api/divisions?filter={"include":[{"relation":"ministries","scope":{"order":["name asc"]}},{"relation": "ministryType"}]}`)

    // First option
    _.forEach(event.data.firstOptionMinistries, firstOption => {
      const firstDivision = _.find(divisions.data, { id: firstOption })
      this.firstOptionLists.push({ id: firstDivision.id, name: `${firstDivision.ministries.name} - ${firstDivision.name}` })
    })
    // Second option
    _.forEach(event.data.secondOptionMinistries, secondOption => {
      const secondDivision = _.find(divisions.data, { id: secondOption })
      this.secondOptionLists.push({ id: secondDivision.id, name: `${secondDivision.ministries.name} - ${secondDivision.name}` })
    })

    // Servolution type
    const servolutionMinistryType = await this.$http.get(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/types`)
    _.forEach(servolutionMinistryType.data, type => {
      this.servolutionTypeOptions.push({ id: type.id, name: type.name })
    })

    // Insert to servolution event variable
    this.servolutionEvents = event.data
    
    // First second ministry type
    const firstSecondMinistryOption = _.find(this.firstSecondMinistryTypeOptions, { id: event.data.firstOptionSecondOptionType })
    if (firstSecondMinistryOption) {
      this.firstSecondMinistryType = { id: firstSecondMinistryOption.id, name: firstSecondMinistryOption.name }
      this.readOnlyFirstSecondMinistryType = firstSecondMinistryOption.name
    }

    // Step 1 prefilled
    const church = _.find(this.churchOptions, { id: event.data.churchId })
    this.churches.push({ id: church.id, name: church.name, status: church.status })
    this.open_date = moment(event.data.openDate).format('YYYY-MM-DD')
    this.close_date = moment(event.data.closeDate).format('YYYY-MM-DD')
    this.maximum_approval_date = moment(event.data.maximumApprovalDate).format('YYYY-MM-DD')

    // Step 2 prefilled
    this.nij_required = event.data.nijRequirement ? 'yes' : 'no'
    this.baptism_required = event.data.baptismRequirement ? 'yes' : 'no'
    this.isAssessmentBroadcasted = event.data.isAssessmentBroadcasted ? 'yes' : 'no'
    const msj = _.find(this.msjOptions, { id: event.data.msjRequirement })
    this.msjSelected = { id: msj.id, name: msj.name }
    this.termsConditions = event.data.termsAndConditions

    // Step 3 prefilled
    const type = _.find(this.servolutionTypeOptions, { id: event.data.servolutionTypeId })
    this.servolutionType = { id: type.id, name: type.name }
    this.readOnlyServolutionType = type.name

    // console.log(this.firstOptionLists)
    // console.log(this.secondOptionLists)

    // Hide the loading bar
    this.isLoading = false
  },
  methods: {
    formSubmitted() {
      // Check for cookies before submit
      // Get logged in status
      const isLoggedIn = isUserLoggedIn()
      // If not logged in, then redirect to login page
      if (!isLoggedIn) {
        return this.$router.replace('/login')
      }

      // Show loading
      this.isLoading = true

      // Check for servolution type
      let firstOptions = []
      let secondOptions = []
      if (this.servolutionType.id === 1) {
        firstOptions = this.firstOptionLists.map(o => o.id)
        secondOptions = this.secondOptionLists.map(o => o.id)
      } else {
        firstOptions = this.servolutionOptionLists.map(o => o.id)
      }

      // Set the events data
      const eventsData = {
        churchId: this.churches[0].id,
        churchName: this.churches[0].name,
        openDate: moment(this.open_date).format('YYYY-MM-DD'),
        closeDate: moment(this.close_date).format('YYYY-MM-DD'),
        maximumApprovalDate: moment(this.maximum_approval_date).format('YYYY-MM-DD'),
        baptismRequirement: this.baptism_required === 'yes',
        msjRequirement: this.msjSelected.id,
        nijRequirement: this.nij_required === 'yes',
        isAssessmentBroadcasted: this.isAssessmentBroadcasted === 'yes',
        servolutionTypeId: this.servolutionType.id,
        firstOptionMinistries: `{ ${firstOptions.map(elem => (`${elem}`)).join(',')} }`,
        secondOptionMinistries: `{ ${secondOptions.map(elem => (`${elem}`)).join(',')} }`,
        firstOptionSecondOptionType: this.firstSecondMinistryType && this.servolutionType.id === 1 ? this.firstSecondMinistryType.id : -1,
        termsAndConditions: this.termsConditions,
        updatedAt: new Date(),
      }

      // Delete the event details if first option lists changed
      // const lastSavedMinistries = _.concat(this.event.firstOptionMinistries, this.event.secondOptionMinistries)
      // const newMinistries = _.concat(this.firstOptions, this.secondOptions)
      // _.forEach(lastSavedMinistries, async ministry => {
      //   // Check if the id is still needed
      //   const ministryIndex = newMinistries.indexOf(ministry)
        
      //   // Delete if -1
      //   if (ministryIndex < 0) {
      //     // Delete
      //     await this.$http.patch(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/event/details/delete?[where][servolutionEventsId]=${this.event.id}&[divisionsId]=${ministry}`, { deletedAt: new Date() })
      //   }
      // })

      // // Check if first and second ministry is needed
      // if (this.firstSecondMinistryType && this.servolutionType.id === 1) {
      //   eventsData.firstOptionSecondOptionType = this.firstSecondMinistryType.id
      // }

      // Check if user has access
      if (!this.$can('update', 'servolution_event')) {
        return this.$router.replace({ name: 'misc-not-authorized' })
      }

      // Check for overlapping events with the previous one
      let isOverlapped = false
      this.$http.get(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/events/church/${this.churches[0].id}`)
        .then(events => {
          console.log(events)
          if (!_.isEmpty(events.data)) {
            // loop
            _.every(events.data, event => {
              if (event.id !== this.$route.params.id) {
                if ((moment(moment(eventsData.openDate).format('YYYY-MM-DD')).isSameOrAfter(moment(event.openDate).format('YYYY-MM-DD')) && moment(moment(eventsData.openDate).format('YYYY-MM-DD')).isSameOrBefore(moment(event.closeDate).format('YYYY-MM-DD'))) || (moment(moment(event.openDate).format('YYYY-MM-DD')).isSameOrAfter(moment(eventsData.openDate).format('YYYY-MM-DD')) && moment(moment(event.openDate).format('YYYY-MM-DD')).isSameOrBefore(moment(eventsData.closeDate).format('YYYY-MM-DD')))) {
                  // Response
                  isOverlapped = true
                  return false
                }
              }

              return true
            })

            // Check if there's an overlapping date
            if (isOverlapped) {
              // Redirect to event lists
              return this.$router.replace({ name: 'servolution-events' })
                .then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'Error',
                      icon: 'XIcon',
                      variant: 'danger',
                      text: 'Event date is overlapping with the previous event creation.',
                    },
                  })
                })
            }
          }

          // Save event
          const eventId = this.$route.params.id
          this.$http.patch(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/events/${eventId}`, eventsData)
            .then(async () => {
              // Get from custom table
              const existingChurchMinistries = await this.$http.get(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/church/ministry/${this.churches[0].id}`)
                
              // Save custom church ministries
              // Auditions and interviews
              _.forEach(this.auditions, async audition => {
                const auditionData = {}
                auditionData.churchId = this.churches[0].id
                auditionData.divisionsId = audition.id
                auditionData.ministryTypeId = 1
                auditionData.updatedAt = new Date()

                if (!_.isEmpty(existingChurchMinistries.data)) {
                  const churchMinistry = _.find(existingChurchMinistries.data, { churchId: this.churches[0].id, divisionsId: auditionData.divisionsId })
                  if (!(_.isNull(churchMinistry) || _.isUndefined(churchMinistry))) {
                    await this.$http.patch(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/church/ministry/${churchMinistry.id}`, auditionData)
                  } else {
                    await this.$http.post(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/church/ministry`, auditionData)
                  }
                } else {
                  await this.$http.post(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/church/ministry`, auditionData)
                }
              })

              // Interviews only
              _.forEach(this.interviews, async interview => {
                const interviewData = {}
                interviewData.churchId = this.churches[0].id
                interviewData.divisionsId = interview.id
                interviewData.ministryTypeId = 2
                interviewData.updatedAt = new Date()

                if (!_.isEmpty(existingChurchMinistries.data)) {
                  const churchMinistry = _.find(existingChurchMinistries.data, { churchId: this.churches[0].id, divisionsId: interviewData.divisionsId })
                  if (!(_.isNull(churchMinistry) || _.isUndefined(churchMinistry))) {
                    await this.$http.patch(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/church/ministry/${churchMinistry.id}`, interviewData)
                  } else {
                    await this.$http.post(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/church/ministry`, interviewData)
                  }

                  // Check if the ministry type is changed from first option to second option, if it's then set the audition schedule and room to null
                  const eventDetails = await this.$http.get(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/event/details/${eventId}/${interview.id}`)
                  if (!_.isEmpty(eventDetails.data)) {
                    _.forEach(eventDetails.data, async details => {
                      await this.$http.patch(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/event/details/${details.id}`, { auditionRoom: null, auditionSchedule: null, updatedAt: new Date() })
                    })
                  }
                } else {
                  await this.$http.post(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/church/ministry`, interviewData)
                }
              })
            })

            // hide loading and redirect
            this.isLoading = false

            // Redirect to event lists
            return this.$router.replace({ name: 'servolution-events' })
              .then(() => {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'success',
                    text: 'Data has been saved successfully.',
                  },
                })
              })
          })
    },
    validationFormSchedule() {
      // Loading
      this.isLoading = true

      // Reinitiate
      this.auditions = []
      this.interviews = []

      return new Promise((resolve, reject) => {
        // Check if church status is regional or local
        if (this.churches[0].status === 'local') {
          // Get from custom table
          this.$http.get(`${process.env.VUE_APP_API_BASE_URL}/api/servolution/church/ministry/${this.churches[0].id}`)
            .then(result => {
              // If data is not empty
              if (!_.isEmpty(result.data)) {
                // Stop loading
                this.isLoading = false

                // If type is audition and interview
                if (this.servolutionType.id === 1) {
                  result.data = _.sortBy(result.data, o => o.divisions.ministries.name)
                  _.forEach(result.data, list => {
                    if (list.ministryTypeId === 1) {
                      // Prefilled in step 4
                      // const auditionDivisionIndex = _.indexOf(this.servolutionEvents.firstOptionMinistries, list.divisionsId)
                      // if (auditionDivisionIndex > -1) {
                      //   this.firstOptionLists.push({ id: list.divisionsId, name: `${list.divisions.ministries.name} - ${list.divisions.name}` })
                      // }

                      this.auditions.push(
                        {
                          id: list.divisionsId,
                          ministry: list.divisions.ministries.name,
                          division: list.divisions.name,
                          type: list.ministryTypeId,
                        },
                      )
                    } else {
                      // Prefilled in step 4
                      // const interviewDivisionIndex = _.indexOf(this.servolutionEvents.secondOptionMinistries, list.divisionsId)
                      // if (interviewDivisionIndex > -1) {
                      //   this.secondOptionLists.push({ id: list.divisionsId, name: `${list.divisions.ministries.name} - ${list.divisions.name}` })
                      // }

                      this.interviews.push(
                        {
                          id: list.divisionsId,
                          ministry: list.divisions.ministries.name,
                          division: list.divisions.name,
                          type: list.ministryTypeId,
                        },
                      )
                    }
                  })
                } else {
                  result.data = _.sortBy(result.data, o => o.divisions.ministries.name)
                  _.forEach(result.data, list => {
                    const foundIndex = _.indexOf(this.servolutionEvents.firstOptionMinistries, list.divisionsId)
                    if (foundIndex > -1) {
                      this.servolutionOptionLists.push({
                        id: list.divisionsId,
                        name: `${list.divisions.ministries.name} - ${list.divisions.name}`,
                      })
                    }

                    // this.servolutionOptionListsOptions.push({
                    //   id: list.divisionsId,
                    //   name: `${list.divisions.ministries.name} - ${list.divisions.name}`,
                    // })

                    if (list.ministryTypeId === 1) {
                      this.auditions.push(
                        {
                          id: list.divisionsId,
                          ministry: list.divisions.ministries.name,
                          division: list.divisions.name,
                          type: list.ministryTypeId,
                        },
                      )
                    } else {
                      this.interviews.push(
                        {
                          id: list.divisionsId,
                          ministry: list.divisions.ministries.name,
                          division: list.divisions.name,
                          type: list.ministryTypeId,
                        },
                      )
                    }
                  })
                }
              } else {
                // Get from default
                this.$http.get(`${process.env.VUE_APP_API_BASE_URL}/api/divisions?filter={"include":[{"relation":"ministries","scope":{"order":["name asc"]}},{"relation": "ministryType"}]}`)
                  .then(lists => {
                    // Stop loading
                    this.isLoading = false

                    lists.data = _.sortBy(lists.data, o => o.ministries.name)
                    _.forEach(lists.data, list => {
                      if (list.ministryTypeId === 1) {
                        // Prefilled in step 4
                        const auditionDivisionIndex = _.indexOf(this.servolutionEvents.firstOptionMinistries, list.id)
                        if (auditionDivisionIndex > -1) {
                          this.firstOptionLists.push({ id: list.id, name: `${list.ministries.name} - ${list.name}` })
                        }

                        this.auditions.push(
                          {
                            id: list.id,
                            ministry: list.ministries.name,
                            division: list.name,
                            type: list.ministryTypeId,
                          },
                        )
                      } else {
                        // Prefilled in step 4
                        const interviewDivisionIndex = _.indexOf(this.servolutionEvents.secondOptionMinistries, list.id)
                        if (interviewDivisionIndex > -1) {
                          this.secondOptionLists.push({ id: list.id, name: `${list.ministries.name} - ${list.name}` })
                        }

                        this.interviews.push(
                          {
                            id: list.id,
                            ministry: list.ministries.name,
                            division: list.name,
                            type: list.ministryTypeId,
                          },
                        )
                      }
                    })
                  })
              }
            })
        } else {
          // Get from default
          this.$http.get(`${process.env.VUE_APP_API_BASE_URL}/api/divisions?filter={"include":[{"relation":"ministries","scope":{"order":["name asc"]}},{"relation": "ministryType"}]}`)
            .then(result => {
              // Stop loading
              this.isLoading = false

              result.data = _.sortBy(result.data, o => o.ministries.name)
              _.forEach(result.data, list => {
                if (list.ministryTypeId === 1) {
                  // Prefilled in step 4
                  const auditionDivisionIndex = _.indexOf(this.servolutionEvents.firstOptionMinistries, list.id)
                  if (auditionDivisionIndex > -1) {
                    this.firstOptionLists.push({ id: list.id, name: `${list.ministries.name} - ${list.name}` })
                  }

                  this.auditions.push(
                    {
                      id: list.id,
                      ministry: list.ministries.name,
                      division: list.name,
                      type: list.ministryTypeId,
                    },
                  )
                } else {
                  // Prefilled in step 4
                  const interviewDivisionIndex = _.indexOf(this.servolutionEvents.secondOptionMinistries, list.id)
                  if (interviewDivisionIndex > -1) {
                    this.secondOptionLists.push({ id: list.id, name: `${list.ministries.name} - ${list.name}` })
                  }

                  this.interviews.push(
                    {
                      id: list.id,
                      ministry: list.ministries.name,
                      division: list.name,
                      type: list.ministryTypeId,
                    },
                  )
                }
              })
            })
        }

        this.$refs.schedule.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormRequirements() {
      return new Promise((resolve, reject) => {
        // Check for terms & conditions content
        if (this.termsConditionsLength === 1) {
          this.$swal({
            title: 'Error',
            text: ' Please insert the terms & conditions content',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
          reject()
        }

        this.$refs.requirements.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormMinistryTypes() {
      return new Promise((resolve, reject) => {
        // Empty the option
        this.servolutionOptionListsOptions = []
        this.firstOptionListsOptions = []
        this.secondOptionListsOptions = []

        // Concat from auditions and interviews lists
        this.rows = _.sortBy(_.concat(this.auditions, this.interviews), o => o.ministry)

        // If first and second option
        if (this.servolutionType.id === 1) {
          // First Option
          _.forEach(this.rows, row => {
            this.firstOptionListsOptions.push({ id: row.id, name: `${row.ministry} - ${row.division}` })

            // Check if the audition list contain in the second ministry lists
            // const isInSecondChoice = _.find(this.secondOptionLists, { id: audition.id })
            // if (isInSecondChoice) {
            //   // Move to the first choice
            //   this.firstOptionLists.push({ id: audition.id, name: `${audition.ministry} - ${audition.division}` })

            //   // Remove existing second choice
            //   const removedIndex = _.findIndex(this.secondOptionLists, { id: audition.id })
            //   this.secondOptionLists.splice(removedIndex, 1)
            // }
          })

          // Second Option
          _.forEach(this.interviews, interview => {
            this.secondOptionListsOptions.push({ id: interview.id, name: `${interview.ministry} - ${interview.division}` })

            // Check if the interview list contain in the first ministry lists
            // const isInFirstChoice = _.find(this.firstOptionLists, { id: interview.id })
            // if (isInFirstChoice) {
            //   // Move to the first choice
            //   this.secondOptionLists.push({ id: interview.id, name: `${interview.ministry} - ${interview.division}` })

            //   // Remove existing second choice
            //   const removedIndex = _.findIndex(this.firstOptionLists, { id: interview.id })
            //   this.firstOptionLists.splice(removedIndex, 1)
            // }
          })
        } else {
          _.forEach(this.rows, row => {
            this.servolutionOptionListsOptions.push({ id: row.id, name: `${row.ministry} - ${row.division}` })
          })
        }
        // else {
        //   // All Lists for default value
        //   // const allLists = _.sortBy(_.concat(this.firstOptionLists, this.secondOptionLists), o => o.ministry)
        //   // this.servolutionOptionLists = allLists
        //   // console.log(this.firstOptionLists)
        //   // console.log(this.secondOptionLists)
        //   console.log(this.servolutionOptionLists)

        //   // Concat from auditions and interviews lists
        //   this.rows = _.sortBy(_.concat(this.auditions, this.interviews), o => o.ministry)
        //   this.servolution
        //   _.forEach(this.rows, row => {
        //     this.servolutionOptionListsOptions.push({ id: row.id, name: `${row.ministry} - ${row.division}` })
        //   })
        // }

        // Validate
        this.$refs.ministryTypes.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormMinistryOptions() {
      return new Promise((resolve, reject) => {
        this.$refs.ministryOptions.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    onEditorReady(quill) {
      this.termsConditionsLength = quill.getLength()
    },
    onEditorChange({ quill }) {
      this.termsConditionsLength = quill.getLength()
    },
    firstOptionSelected() {
      const currentSelected = _.find(this.firstOptionLists, { id: this.firstOptionLists[this.firstOptionLists.length - 1].id })
      const isExistsInSecondOptions = _.find(this.secondOptionLists, { id: currentSelected.id })

      if (isExistsInSecondOptions) {
        const index = _.findIndex(this.secondOptionLists, { id: currentSelected.id })
        this.secondOptionLists.splice(index, 1)
      }
    },
    secondOptionSelected() {
      const currentSelected = _.find(this.secondOptionLists, { id: this.secondOptionLists[this.secondOptionLists.length - 1].id })
      const isExistsInFirstOptions = _.find(this.firstOptionLists, { id: currentSelected.id })

      if (isExistsInFirstOptions) {
        const index = _.findIndex(this.firstOptionLists, { id: currentSelected.id })
        this.firstOptionLists.splice(index, 1)
      }
    },
  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/vue/libs/quill.scss';
</style>